export default __webpack_public_path__ + "static/media/Chevron.ae2c102f.svg";